import { render, staticRenderFns } from "./Medicinal.vue?vue&type=template&id=5bcad42e&"
import script from "./Medicinal.vue?vue&type=script&lang=js&"
export * from "./Medicinal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports